type Props = {};

export default function Page1({}: Props) {
	return (
		<>
			<h1 className="text-5xl font-medium border-b-2 border-b-customBlue w-fit pb-2">Helloooooo</h1>
			<p className="text-xl tracking-wide">
				Z okacji, że dziś wypada przypadkiem taki dzień jak 23.06.2025 r. (czyliiii dzień ojca) to chciałem zaproponować Panu dwie opcje do wyboru
				i do wspólnego pójścia do kinaaaa. Jeden z tych filmów jest zwieńczem długiieeeej i kultowej serii składającej się z 8 filmów, w których
				głowną rolę gra akrobata Tom Cruise. Drugi z kolei ma swoją premierę w tym tygodniu i poświecony jest pojazdom na kręcących się kółkach
				(całkiem szybkich, choć z Citroenem miałyby problem), które gonią się po pętli.
			</p>
			<i className="text-white text-lg">
				PS: link tej strony tj. d9b5989ea1a82edfd722cd5ffe6ba6d026ff00b369bf8ff7f332165a717c07de - to wynik funkcji hashującej SHA256, którą sam
				zaprogramowałem jakiś czas temu jako jeden z projektów i oznacza "Dzień Ojca"
			</i>
			<i className="text-customBlue">Decyzję proszę przekazać do administratora strony</i>
		</>
	);
}
